module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "top-pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-area"
  }, [_c('h3', [_vm._v(_vm._s(_vm.data.viewType == 'bigimage' ? (_vm.data.showTitle ? _vm.data.title : '') : (_vm.data.showTitle ? _vm.data.listTitle : _vm.data.title)))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.data.description))])]), _vm._v(" "), (_vm.data.blockType != 1) ? _c('div', {
    staticClass: "lable-ul"
  }, [_c('div', {
    staticClass: "label-ul-content"
  }, [_c('ul', _vm._l((_vm.blocks), function(item, index) {
    return (_vm.blocks && _vm.blocks.length) ? _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.toggleBlock(index, $event)
        }
      }
    }, [_vm._v(_vm._s(item.title))])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.blocks), function(item, index) {
    return (_vm.blocks && _vm.blocks.length) ? _c('section', [_c('header', {
      staticClass: "flex flex-cross-center",
      attrs: {
        "id": _vm.generateElementId(index)
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v("∕"), _c('span', [_vm._v(_vm._s(_vm.data.blocks.length))]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('ul', _vm._l((item.articles), function(article) {
      return _c('li', {
        key: article.id,
        staticClass: "flex flex-main-justify",
        on: {
          "click": function($event) {
            return _vm.goPath(article)
          }
        }
      }, [(article.type === 'live') ? _c('div', {
        staticStyle: {
          "width": "100%"
        }
      }, [_c('div', {
        staticClass: "title"
      }, [(article.tags && article.type === 'subject') ? _c('span', {
        staticClass: "tag_label"
      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), (article.liveType != 3 && article.images) ? _c('div', {
        staticClass: "pic-wrap-2"
      }, [_c('img', {
        attrs: {
          "src": article.images[0],
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        class: 'living-label-' + article.liveStatus
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "flex flex-main-justify date"
      }, [_c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))]), _vm._v(" "), (article.hits > 0) ? _c('span', [_vm._v(_vm._s(article.hits) + "人参与")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (article.viewType === 'three') ? _c('div', {
        staticStyle: {
          "height": "100%",
          "width": "100%"
        }
      }, [_c('div', {
        staticClass: "title"
      }, [(article.tags && article.type === 'subject') ? _c('span', {
        staticClass: "tag_label"
      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
        staticClass: "three-list flex"
      }, [_vm._l((article.images), function(img) {
        return _c('div', {
          key: img,
          staticClass: "img",
          style: ({
            backgroundImage: 'url(' + img + ')'
          })
        })
      }), _vm._v(" "), (article.type === 'image') ? _c('div', {
        staticClass: "images-label"
      }, [_vm._v(_vm._s(article.medias && article.medias.length > 0 ? article.medias.length : 0) + "图")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
        staticClass: "flex-default date",
        staticStyle: {
          "justify-content": "flex-start"
        }
      }, [_c('div', {
        staticClass: "tag ellipsis"
      }, [(article.type != 'subject') ? _c('span', {
        staticClass: "tag-red",
        domProps: {
          "innerHTML": _vm._s(article.tags)
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(article.source)
        }
      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : (article.viewType === 'bannerSmall') ? _c('div', {
        staticStyle: {
          "width": "100%"
        }
      }, [_c('div', {
        staticClass: "img-frame-small"
      }, [(article.images) ? _c('div', {
        staticClass: "img-bac",
        style: ('background:url(' + article.images[0] + ') no-repeat;background-size:100%')
      }) : _vm._e()])]) : (article.viewType === 'banner') ? _c('div', {
        staticStyle: {
          "height": "100%",
          "width": "100%"
        }
      }, [(article.type === 'normal') ? _c('div', [_c('div', {
        staticClass: "title"
      }, [(article.tags && article.type === 'subject') ? _c('span', {
        staticClass: "tag_label"
      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
        staticClass: "pic-wrap"
      }, [_c('img', {
        attrs: {
          "src": article.image,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "description",
        domProps: {
          "innerHTML": _vm._s(article.description)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "flex-default date",
        staticStyle: {
          "justify-content": "flex-start"
        }
      }, [_c('div', {
        staticClass: "tag ellipsis"
      }, [(article.type != 'subject') ? _c('span', {
        staticClass: "tag-red",
        domProps: {
          "innerHTML": _vm._s(article.tags)
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(article.source)
        }
      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : (article.type === 'video') ? _c('div', [_c('div', {
        staticClass: "title"
      }, [(article.tags && article.type === 'subject') ? _c('span', {
        staticClass: "tag_label"
      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
        staticClass: "pic-wrap"
      }, [_c('img', {
        attrs: {
          "src": article.images[0],
          "alt": ""
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "content-button"
      })]), _vm._v(" "), _c('div', {
        staticClass: "flex-default date",
        staticStyle: {
          "justify-content": "flex-start"
        }
      }, [_c('div', {
        staticClass: "tag ellipsis"
      }, [(article.type != 'subject') ? _c('span', {
        staticClass: "tag-red",
        domProps: {
          "innerHTML": _vm._s(article.tags)
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(article.source)
        }
      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : _c('div', [_c('div', {
        staticClass: "title"
      }, [(article.tags && article.type === 'subject') ? _c('span', {
        staticClass: "tag_label"
      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), (article.images) ? _c('div', {
        staticClass: "pic-wrap"
      }, [_c('img', {
        attrs: {
          "src": article.images[0],
          "alt": ""
        }
      }), _vm._v(" "), (article.type === 'image') ? _c('div', {
        staticClass: "images-label"
      }, [_vm._v(_vm._s(article.medias && article.medias.length > 0 ? article.medias.length : 0) + "图")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "description",
        domProps: {
          "innerHTML": _vm._s(article.description)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "flex-default date",
        staticStyle: {
          "justify-content": "flex-start"
        }
      }, [_c('div', {
        staticClass: "tag ellipsis"
      }, [(article.type != 'subject') ? _c('span', {
        staticClass: "tag-red",
        domProps: {
          "innerHTML": _vm._s(article.tags)
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(article.source)
        }
      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])])]) : [_c('div', {
        staticClass: "info",
        staticStyle: {
          "width": "100%"
        }
      }, [_c('div', {
        staticClass: "title"
      }, [(article.tags && article.type === 'subject') ? _c('span', {
        staticClass: "tag_label_2"
      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
        staticClass: "flex date"
      }, [_c('div', {
        staticClass: "tag ellipsis",
        staticStyle: {
          "justify-content": "flex-start"
        }
      }, [(article.type != 'subject') ? _c('span', {
        staticClass: "tag-red",
        domProps: {
          "innerHTML": _vm._s(article.tags)
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(article.source)
        }
      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]), _vm._v(" "), (article.images) ? _c('div', {
        staticClass: "thumbnail",
        style: ({
          backgroundImage: 'url(' + article.images[0] + ')'
        })
      }, [_c('i', {
        class: [article.type + '-icon']
      })]) : _vm._e()]], 2)
    }), 0), _vm._v(" "), (item.page.next * 1 <= item.page.last * 1) ? _c('footer', {
      on: {
        "click": function($event) {
          return _vm.getArticles(item.id, index)
        }
      }
    }, [_vm._v("加载更多")]) : _vm._e()]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d86e5e6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-topic2.vue
// module id = 866
// module chunks = 2